<template>
    <div class="odd-labels">
        <div class="" v-if="ou" v-for="odd in ou.odd"
             v-tooltip="ou.name">
            <Selection :selectedOdds="selectedOdds" :odd="odd" :match="match" :market="ou"></Selection>
        </div>
    </div>
</template>

<script>
    import betSlip from '@/mixins/betSlip'
    import Selection from "./selection";

    export default {
        name: 'mainOdds',
        components: {Selection},
        mixins: [betSlip],
        props: {
            market: {
                type: Number,
                default: 1
            },
            onLive: false,
            odds: {},
            match: {},
            selectedOdds: {}
        },
        data() {
            return {
                t: this.$root.t,
                ouDefault: {"id":"0","name":"","disabled":false,"closed":false,"hcp":"0:0","market":1,"markets":[1],"column":3,"layout":1,"order":3,"odd":{"1":{"id":14313037,"oddType":1,"outcome":"1","odd":"56.00","sp":"0.00","live":true,"active":false,"order":1,"change":"","r":"Waiting","resultId":1},"2":{"id":14313035,"oddType":1,"outcome":"X","odd":"5.80","sp":"0.00","live":true,"active":false,"order":2,"change":"","r":"Waiting","resultId":1},"3":{"id":14313034,"oddType":1,"outcome":"2","odd":"1.10","sp":"0.00","live":true,"active":false,"order":3,"change":"","r":"Waiting","resultId":1}}},
                ou: {"id":"0","name":"","disabled":false,"closed":false,"hcp":"0:0","market":1,"markets":[1],"column":3,"layout":1,"order":3,"odd":{"1":{"id":14313037,"oddType":1,"outcome":"1","odd":"56.00","sp":"0.00","live":true,"active":false,"order":1,"change":"","r":"Waiting","resultId":1},"2":{"id":14313035,"oddType":1,"outcome":"X","odd":"5.80","sp":"0.00","live":true,"active":false,"order":2,"change":"","r":"Waiting","resultId":1},"3":{"id":14313034,"oddType":1,"outcome":"2","odd":"1.10","sp":"0.00","live":true,"active":false,"order":3,"change":"","r":"Waiting","resultId":1}}},
            }
        },
        watch: {
            odds: {
                handler() {
                    this.checkSpecialValue();
                },
                deep: true
            },
        },
        mounted() {
            this.ou = this.ouDefault;
            //this.fetchSelectedBets();
            this.checkSpecialValue();

            this.$bus.$on('fixture_state_'+this.match.matchId, (payload) => {

                if(payload.eventId == this.match.matchId){

                    if(payload.dataId == this.ou.id){
                        if(payload.command === 'update_market' || payload.command === 'insert_market'){
                            this.ou = payload.data;
                        }
                    }
                }
            });

        },
        methods: {
            checkSpecialValue() {
                if (!this.odds)
                    return false;

                this.ou = this.ouDefault;
                Object.keys(this.odds).forEach((key) => {
                    if (this.odds[key].market === this.market) {
                        this.ou = this.odds[key];
                    }
                });
            },
            fetchSelectedBets() {

            },
        }
    }
</script>

<style scoped>
    .odd-labels {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-width: 117px;
    }

    .odd-labels.pre {
        flex: 0 0 22%;
    }
</style>



// WEBPACK FOOTER //
// src/components/sportsbook/mainOdds.vue